import React from 'react'
import { useStyles } from './styles'

export const ArtistNote = ({ body, onClick }) => {
    const classes = useStyles()

    return (
        <pre className={classes.note} onClick={onClick}>
            {body}
        </pre>
    )
}
